'use strict';

angular.module('lmsApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('bookshelf', {
                parent: 'entity',
                url: '/bookshelf',
                data: {
                    roles: ['OP_VIEW_BOOKSHELF'],
                    pageTitle: 'lmsApp.bookshelf.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/student/bookshelf/bookshelfs.html',
                        controller: 'BookshelfController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bookshelf');
                        return $translate.refresh();
                    }]
                }
            })
            .state('bookshelfDetail', {
                parent: 'entity',
                url: '/bookshelf/:id',
                data: {
                    roles: ['OP_VIEW_BOOKSHELF'],
                    pageTitle: 'lmsApp.bookshelf.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/student/bookshelf/bookshelf-detail.html',
                        controller: 'BookshelfDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bookshelf');
                        return $translate.refresh();
                    }]
                }

            });
    });
